import {
  PROJECT_INFO,
  SET_ACTIVE_PROJECT,
  SET_ACTIVE_PROJECT_STATISTICS,
  SET_PROJECT_LOCKING_STATUS,
  SET_USER_PROJECTS,
} from '@state-management/constants';
import { ProjectLockStatus, TypedCacheBucket } from '../models/state.models';
import { ProjectStatistics } from '../reducers/projects';

export class SetProjectAction {
  readonly type = SET_USER_PROJECTS;
  constructor(public readonly payload?: { data: unknown[] }) {}
}

export class SetActiveProjectAction {
  readonly type = SET_ACTIVE_PROJECT;
  constructor(public readonly payload?: { data: unknown | null }) {}
}

export class SetActiveProjectStatisticsAction {
  readonly type = SET_ACTIVE_PROJECT_STATISTICS;
  constructor(public readonly payload?: { data: ProjectStatistics | null }) {}
}

export class SetProjectInfo {
  readonly type = PROJECT_INFO;
  constructor(public readonly payload?: { data: TypedCacheBucket | null }) {}
}

export class SetProjectLockingStatusAction {
  readonly type = SET_PROJECT_LOCKING_STATUS;
  constructor(public readonly payload?: { data: ProjectLockStatus }) {}
}
